import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m16 19.2-4.702 3.272 1.659-5.483-4.565-3.461 5.727-.117L16 8l1.881 5.411 5.727.117-4.565 3.46 1.66 5.484z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagVnm = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagVnm_default = SvgFlagVnm;

export { FlagVnm_default as default };
